<template>
  <div class="my-listing-form-wrapper padding-20 k-page pos-relative">
    <h2 style="color:#000;" class="text-center">Welcome Technology Provider!</h2>
    <h2 style="color:#000;" class="text-center padding-b-20">Please complete this form and submit your listing.</h2>
    <section id="general-section">
      <GeneralInformation ref="general" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="about-section">
      <About ref="about" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="overview-section">
      <Overview ref="overview" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="location-section">
      <Location ref="location" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="categories-section">
      <Categories ref="categories" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="video-section">
      <Video ref="video" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section id="gallery-section">
      <Galleries ref="gallery" v-model="formData" style="margin-bottom:20px;" @success="handleFailedSubmit"/>
    </section>
    <section  id="references-section">
      <References ref="references" v-model="formData" style="margin-bottom:20px;"/>
    </section>
    <section  id="events-section">
      <Events ref="events" v-model="formData" style="margin-bottom:20px;"/>
    </section>
    <section>
      <SocialNetworks ref="social-networks" v-model="formData" style="margin-bottom:20px;"/>
    </section>
    <section  id="responsible-company-section">
      <ResponsibleCompany ref="responsible-company" v-model="formData.responsible_company[0]" style="margin-bottom:20px;"/>
    </section>
    <section class="text-center">
      <Button class="k-btn-1" @click="handleSubmitListing()" :loading="isSaving">{{ (this.formData.id)? 'Save':'Submit' }}</Button>
    </section>
    <Navigations  @scroll="handleScrollTo"/>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { addCompanies, updateCompanyBySlug, fetchCompanyBySlug } from '@/services/companies'
import GeneralInformation from './GeneralInformation'
import About from './About'
import Overview from './Overview'
import Location from './Location'
import Categories from './Categories'
import Galleries from './Galleries'
import Navigations from './Navigations'
import Video from './Video'
import ResponsibleCompany from './ResponsibleCompany'
import References from './References'
import Events from './Events'
import SocialNetworks from './SocialNetworks'

export default {
  components: {
    GeneralInformation,
    About,
    Overview,
    Location,
    Categories,
    Galleries,
    Navigations,
    Video,
    ResponsibleCompany,
    References,
    Events,
    SocialNetworks
  },
  data () {
    return {
      isSuccess: false,
      isLoading: false,
      isSaving: false,
      formData: {
        name: null,
        legal_name: null,
        is_verified: false,
        services: null,
        other_services: null,
        tagline: null,
        tags: null,
        size: null,
        founder: null,
        founded: null,
        address: null,
        latitude: null,
        longitude: null,
        location: null,
        website: null,
        customer_email: null,
        telephone: null,
        description: null,
        cover_photo: '',
        logo: null,
        register_link: null,
        solutions_to_problems: null,
        other_location: null,
        file_download: [],
        video_url: null,
        gallery: [],
        reference: null,
        event: null,
        sns: [],
        newcategory: [],
        responsible: [],
        responsible_company: [{
          gdr_compliance: null,
          web_hosting_location: null,
          security_certification: null,
          green_initiative: null,
          green_label: null,
          csr_certification: null
        }],
        marketapplication: [],
        other_application: null
      },
      oldFormData: null
    }
  },

  mounted () {
    if (this.$route.query && this.$route.query.name) this.getCompany(this.$route.query.name)
  },

  methods: {
    handleScrollTo (val) {
      this.$nextTick(() => {
        this.$refs[val].$el.scrollIntoView({ behavior: 'smooth' })
      })
    },

    getCompany (slug) {
      this.isLoading = true
      fetchCompanyBySlug(slug).then(res => {
        this.oldFormData = JSON.parse(JSON.stringify(res.data))
        this.formData = Object.assign({}, res.data)
        if (!res.data.responsible_company.length) {
          this.formData.responsible_company = [{
            gdr_compliance: null,
            web_hosting_location: null,
            security_certification: null,
            green_initiative: null,
            green_label: null,
            csr_certification: null
          }]
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get company details: ', err)
        this.$Message.warning({
          background: true,
          duration: 3,
          content: 'Tech provider does not exist'
        })
        this.$router.push({
          name: 'my-listing'
        })
        this.isLoading = false
      })
    },

    verifyFileUpdates () {
      if (this.formData.cover_photo === this.oldFormData.cover_photo) {
        this.formData.cover_photo = (this.formData.cover_photo_base64) ? this.formData.cover_photo_base64 : ''
      }
      if (this.formData.logo === this.oldFormData.logo) {
        this.formData.logo = (this.formData.logo_base64) ? this.formData.logo_base64 : ''
      }

      this.formData.gallery = this.formData.gallery.reduce((acc, cur) => {
        if (cur.id) {
          const current = this.oldFormData.gallery.find(x => x.id === cur.id)
          if (current.file === cur.file) {
            acc.push({
              file: (cur.file_base64) ? cur.file_base64 : '',
              file_name: cur.file_name
            })
          } else {
            acc.push({
              file: cur.file,
              file_name: cur.file_name
            })
          }
        } else {
          acc.push({
            file: cur.file,
            file_name: cur.file_name
          })
        }
        return acc
      }, [])

      this.formData.file_download = this.formData.file_download.reduce((acc, cur) => {
        if (cur.id) {
          const current = this.oldFormData.file_download.find(x => x.id === cur.id)
          if (current.file === cur.file) {
            acc.push({
              file: (cur.file_base64) ? cur.file_base64 : '',
              file_name: cur.file_name
            })
          } else {
            acc.push({
              file: cur.file,
              file_name: cur.file_name
            })
          }
        } else {
          acc.push({
            file: cur.file,
            file_name: cur.file_name
          })
        }
        return acc
      }, [])
    },

    updateCompany () {
      this.isSaving = true
      this.verifyFileUpdates()
      updateCompanyBySlug(this.$route.query.name, this.formData).then(res => {
        this.isSaving = false
        this.$Message.success({
          background: true,
          duration: 3,
          content: 'Tech provider successfully updated'
        })
        this.$router.push({
          name: 'my-listing'
        })
      }).catch(err => {
        console.log('Failed to update company details: ', err)
        this.isSaving = false
        this.$Message.error({
          background: true,
          duration: 5,
          content: err.response.data.message
        })
      })
    },

    addCompany () {
      this.isSaving = true
      addCompanies(this.formData).then(res => {
        this.isSaving = false
        this.$Message.success({
          background: true,
          duration: 3,
          content: 'Listing successfully submitted'
        })
        this.$router.push({
          name: 'my-listing'
        })
      }).catch(err => {
        this.isSaving = false
        console.log('Failed to submit my listing: ', err)
        this.$Message.error({
          background: true,
          duration: 5,
          content: err.response.data.message
        })
      })
    },

    handleSubmitListing () {
      this.isSuccess = true
      this.$refs.general.handleSubmit()
      this.$refs.about.handleSubmit()
      this.$refs.overview.handleSubmit()
      this.$refs.location.handleSubmit()
      this.$refs.categories.handleSubmit()

      if (this.isSuccess) {
        if (this.formData.id) {
          this.updateCompany()
        } else {
          this.addCompany()
        }
      } else {
        this.$Message.error('Please fill in all the required fields')
      }
    },

    handleFailedSubmit (val) {
      if (!val) this.isSuccess = false
    }
  }
}
</script>
